import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import React, { Component, createRef } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { toggleMobileMenu } from 'reducers/layout/reducer'
import { ReactComponent as Logo } from 'assets/img/logo-new.svg'
import SidenavContent from './SidenavContent'
import { StyledLogo } from './Sidenav.styles'

class Sidenav extends Component {
  sidebarRef = createRef()

  sidebarClickHandler = e => {
    const { hideMenu, toggleMobileMenu } = this.props
    const { current } = this.sidebarRef
    const { target } = e

    if (current && target instanceof Node && !current.contains(target)) {
      hideMenu()
      toggleMobileMenu()
    }
  }

  render() {
    const { hideMenu, featureFlags } = this.props
    const isMobileResolution = ifWindowWidthLessThan(LAPTOP_BREAKPOINT)

    return (
      <div className="app-sidebar" onClick={this.sidebarClickHandler}>
        {featureFlags.APP_HEADER_V2 && !isMobileResolution && (
          <StyledLogo to="/">
            <Logo />
          </StyledLogo>
        )}
        <section className="sidebar-content" ref={this.sidebarRef}>
          <SidenavContent onMenuHide={hideMenu} />
        </section>
        <section className="sidebar-footer">
          <ul className="nav">
            <li>
              <Link to="/">
                <i className="nav-icon material-icons">archive</i>
                <span className="nav-text">
                  Build: {window._env.REACT_APP_VERSION}
                </span>
              </Link>
            </li>
          </ul>
        </section>
      </div>
    )
  }
}

const enhance = connect(
  state => ({
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    toggleMobileMenu,
  },
)

export default enhance(withRouter(Sidenav))
